import { TunnelProtocolEnum, TunnelProtocolToPort } from "@/model/data/enums/TunnelProtocolEnum";
import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { GetAgentTunnelServiceConnectedTimeResData } from "./GetAgentTunnelServiceConnectedTimeResData";

const ENDPOINT = "/remotelink/session/history";

export class GetAgentTunnelServiceConnectedTimeCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";
    params: GetAgentTunnelServiceConnectedTimeReqData = null;

    constructor(installationName: string, protocol: TunnelProtocolEnum) {
        super();
        this.params = new GetAgentTunnelServiceConnectedTimeReqData(installationName, TunnelProtocolToPort(protocol));
    }

    public async execute(): Promise<GetAgentTunnelServiceConnectedTimeResData> {
        var res = await this.executeCommand(null, null, this.params);
        return new GetAgentTunnelServiceConnectedTimeResData(res);
    }
}

export class GetAgentTunnelServiceConnectedTimeReqData {
    // FilterInstallations
    installationName: string = null;
    servicePort: number;

    constructor(installationName: string, servicePort: number) {
        this.installationName = installationName;
        this.servicePort = servicePort;
    }
}
